import { useEffect, useState } from 'react';
import { auditoriaService } from '../services/api';
import { Filter } from 'lucide-react';

const MODULOS = ['todos','auth','caja','comandas','inventario','usuarios'];
const MOD_COLOR: Record<string, { bg: string; txt: string }> = {
  auth:       { bg: '#F3E8FF', txt: '#7C3AED' },
  caja:       { bg: 'var(--ok-bg)', txt: 'var(--ok)' },
  comandas:   { bg: 'var(--info-bg)', txt: 'var(--info)' },
  inventario: { bg: 'var(--warn-bg)', txt: 'var(--warn)' },
  usuarios:   { bg: '#FCE7F3', txt: '#DB2777' },
};

function fmt(iso: string) {
  return new Date(iso).toLocaleString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

const th: React.CSSProperties = { padding: '10px 16px', fontSize: 11, fontWeight: 600, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left' };
const td: React.CSSProperties = { padding: '10px 16px', fontSize: 13, color: 'var(--ink-2)', borderTop: '1px solid var(--line-2)' };

export default function Auditoria() {
  const hoy = new Date().toISOString().slice(0, 10);
  const [fi, setFi]           = useState(hoy);
  const [ff, setFf]           = useState(hoy);
  const [modulo, setModulo]   = useState('todos');
  const [registros, setReg]   = useState<any[]>([]);
  const [cargando, setCarg]   = useState(false);
  const [selec, setSelec]     = useState<any>(null);

  const consultar = async () => {
    setCarg(true);
    try {
      const params: any = { fecha_inicio: fi, fecha_fin: ff, limite: 200 };
      if (modulo !== 'todos') params.modulo = modulo;
      const r = await auditoriaService.get(params);
      setReg(r.data);
    } catch {}
    finally { setCarg(false); }
  };

  useEffect(() => { consultar(); }, []);

  return (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-.02em', margin: 0 }}>Auditoría</h1>
        <p style={{ fontSize: 13, color: 'var(--muted)', margin: '2px 0 0' }}>Registro de todas las acciones del sistema</p>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 12, padding: '14px 16px', marginBottom: 16, display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', boxShadow: '0 1px 3px rgba(0,0,0,.06)' }}>
        {[{ label: 'Desde', value: fi, set: setFi }, { label: 'Hasta', value: ff, set: setFf }].map(({ label, value, set }) => (
          <div key={label}>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', display: 'block', marginBottom: 5 }}>{label}</label>
            <input type="date" value={value} onChange={e => set(e.target.value)} style={{ height: 36, border: '1px solid var(--line-strong)', borderRadius: 8, padding: '0 10px', fontSize: 13, outline: 'none', fontFamily: 'inherit' }} />
          </div>
        ))}
        <div>
          <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', display: 'block', marginBottom: 5 }}>Módulo</label>
          <select value={modulo} onChange={e => setModulo(e.target.value)} style={{ height: 36, border: '1px solid var(--line-strong)', borderRadius: 8, padding: '0 10px', fontSize: 13, outline: 'none', background: 'var(--surface)', fontFamily: 'inherit', cursor: 'pointer', minWidth: 130 }}>
            {MODULOS.map(m => <option key={m} value={m}>{m === 'todos' ? 'Todos los módulos' : m.charAt(0).toUpperCase() + m.slice(1)}</option>)}
          </select>
        </div>
        <button onClick={consultar} disabled={cargando}
          style={{ display: 'flex', alignItems: 'center', gap: 6, height: 36, padding: '0 16px', background: 'var(--brand)', color: 'var(--on-brand)', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: cargando ? 'not-allowed' : 'pointer', opacity: cargando ? .7 : 1 }}>
          <Filter size={14} /> {cargando ? 'Cargando…' : 'Consultar'}
        </button>
        <span style={{ fontSize: 13, color: 'var(--muted)', marginLeft: 'auto', alignSelf: 'center' }}>{registros.length} registro{registros.length !== 1 ? 's' : ''}</span>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,.06)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ background: 'var(--bg)' }}>
            <tr>
              <th style={th}>Fecha</th>
              <th style={th}>Usuario</th>
              <th style={th}>Acción</th>
              <th style={th}>Módulo</th>
              <th style={th}>IP</th>
            </tr>
          </thead>
          <tbody>
            {cargando && <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: 'var(--faint)', padding: '40px 16px' }}>Cargando…</td></tr>}
            {!cargando && registros.length === 0 && <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: 'var(--faint)', padding: '40px 16px' }}>Sin registros para este período</td></tr>}
            {!cargando && registros.map((r, i) => {
              const mc = MOD_COLOR[r.modulo] || { bg: 'var(--well)', txt: 'var(--ink-2)' };
              return (
                <tr key={i} style={{ cursor: 'pointer' }} onClick={() => setSelec(selec?.id === r.id ? null : r)}>
                  <td style={{ ...td, color: 'var(--muted)', whiteSpace: 'nowrap', fontSize: 12 }}>{fmt(r.fecha)}</td>
                  <td style={td}><span style={{ fontWeight: 500 }}>{r.usuario_nombre || r.usuario || '—'}</span></td>
                  <td style={td}>{r.accion}</td>
                  <td style={td}><span style={{ fontSize: 12, fontWeight: 600, padding: '2px 9px', borderRadius: 999, background: mc.bg, color: mc.txt }}>{r.modulo}</span></td>
                  <td style={{ ...td, color: 'var(--faint)', fontSize: 12 }}>{r.ip || '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {selec && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.4)' }} onClick={() => setSelec(null)} />
          <div style={{ position: 'relative', background: 'var(--surface)', borderRadius: 14, boxShadow: '0 20px 60px rgba(0,0,0,.2)', width: 480, maxHeight: '80vh', overflowY: 'auto', padding: 24 }}>
            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 16 }}>Detalle del evento</div>
            {[
              { l: 'Fecha', v: fmt(selec.fecha) },
              { l: 'Usuario', v: selec.usuario_nombre || selec.usuario },
              { l: 'Acción', v: selec.accion },
              { l: 'Módulo', v: selec.modulo },
              { l: 'IP', v: selec.ip || '—' },
            ].map(({ l, v }) => (
              <div key={l} style={{ display: 'flex', marginBottom: 10 }}>
                <span style={{ width: 80, fontSize: 12, fontWeight: 600, color: 'var(--muted)', flexShrink: 0 }}>{l}</span>
                <span style={{ fontSize: 13 }}>{v}</span>
              </div>
            ))}
            {selec.detalle && (
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 6 }}>Detalle</div>
                <pre style={{ background: 'var(--bg)', borderRadius: 8, padding: 12, fontSize: 12, overflowX: 'auto', margin: 0 }}>
                  {typeof selec.detalle === 'string' ? selec.detalle : JSON.stringify(selec.detalle, null, 2)}
                </pre>
              </div>
            )}
            <button onClick={() => setSelec(null)} style={{ marginTop: 16, width: '100%', height: 38, border: '1px solid var(--line-strong)', borderRadius: 8, background: 'var(--surface)', fontSize: 13, cursor: 'pointer' }}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
}
